export const MAX_MODAL_DIALOG_SHOWN_COUNT = 5;
